module.exports = __webpack_public_path__ + "img/map_select.8a08f48d.png";